"use client";

import { useRef } from "react";

import { FallbackImage } from "@/components/fallback-image";
import { useInView } from "@/hooks/use-in-view";
import { useReleaseImagesResource } from "@/hooks/use-release-images-resource";
import { cn } from "@/lib/utils";
import { buildReleaseImageSrcSet, buildReleaseImageUrl } from "@garimpa/lib/imageUrls";

interface DeferredReleaseCoverProps {
  className?: string;
  imageCount?: number | null;
  releaseId: string;
  showLoadingSpinner?: boolean;
  sizes: string;
  title: string;
}

export function DeferredReleaseCover({
  className,
  imageCount,
  releaseId,
  showLoadingSpinner,
  sizes,
  title,
}: DeferredReleaseCoverProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const inView = useInView(containerRef, { rootMargin: "300px" });
  const { images } = useReleaseImagesResource(releaseId, {
    enabled: imageCount == null && inView,
  });
  const hasImage = (imageCount ?? images.length) > 0;

  return (
    <div ref={containerRef} className={cn("h-full w-full", className)}>
      <FallbackImage
        src={hasImage ? buildReleaseImageUrl(releaseId, { width: 150 }) : null}
        srcSet={hasImage ? buildReleaseImageSrcSet(releaseId, [150, 320]) : undefined}
        alt={title}
        showLoadingSpinner={showLoadingSpinner}
        sizes={sizes}
      />
    </div>
  );
}
